import axios from 'axios';
import { createContext, useContext, useReducer } from 'react';
import { DOC_FORMAT_CONFIG_VALUES } from '../define/global';
import { setAppLoading } from '../store/modules/appLoading';
import { setFileName } from '../store/modules/docInfo';
import { cLog } from '../utils/consoleLog';
import { getS3MetaData } from '../utils/InnerApi';

//import { getFile } from '../utils/s3Connect';

const PO_WEBOFFCE_SDK_INIT = 'PO_WEBOFFCE_SDK_INIT';
const PO_WEBOFFCE_SDK_SUCCESS = 'PO_WEBOFFCE_SDK_SUCCESS';
export const PO_WEBOFFCE_SDK_FAIL = 'PO_WEBOFFCE_SDK_FAIL';

const initialState = {
  poInstance: null,
  isInitializing: false,
  error: null
};

function reducer(state, action) {
  switch (action.type) {
    case PO_WEBOFFCE_SDK_INIT:
      return {
        poInstance: null,
        isInitializing: true,
        error: null
      };
    case PO_WEBOFFCE_SDK_SUCCESS:
      return {
        poInstance: action.payload,
        isInitializing: false,
        error: null
      };
    case PO_WEBOFFCE_SDK_FAIL:
      return {
        poInstance: null,
        isInitializing: false,
        error: action.payload
      };

    default:
      throw new Error('Unkown Acion For poWebOfficeSDKContext');
  }
}

async function _getInstance(targetEle, config) {
  const sdkInstance = await window.PolarisWebOffice(targetEle, config);
  sdkInstance.handle = sdkInstance[DOC_FORMAT_CONFIG_VALUES.sdk.interfaceName];
  return sdkInstance;
}

export async function initPoSDK(dispatch, targetEle, config, storeDispatch, sendGAData) {
  dispatch({ type: PO_WEBOFFCE_SDK_INIT });

  try {
    const start = new Date();
    const instance = await _getInstance(targetEle, config);
    await instance.handle.openNewDocument();
    const end = new Date();

    //For LoadingSplash Check
    //await new Promise((res) => setTimeout(() => res(), 7000));

    storeDispatch(setAppLoading(false));

    dispatch({ type: PO_WEBOFFCE_SDK_SUCCESS, payload: instance });

    sendGAData(end - start);
  } catch (error) {
    storeDispatch(setAppLoading(false));
    dispatch({ type: PO_WEBOFFCE_SDK_FAIL, payload: error });
  }
}

export async function initPoSDKAfteDownload(
  storeDispatch,
  poSDKContextDispatch,
  targetEle,
  config,
  url,
  shareID,
  onSuccess,
  onFail,
  sendGAData
) {
  async function downloadNLoad(url) {
    let fileName = '';
    try {
      try {
        const metaData = await getS3MetaData(shareID);
        fileName = decodeURIComponent(metaData.originalfilename);
        storeDispatch(setFileName(fileName));
      } catch (error) {
        cLog('s3 mataData get fail');
      }

      const start = new Date();
      const data = await axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      });
      const res = data.data;

      //const res = await getFile(shareID);

      const fileNameInDoc = await initPoSDKWithRes(
        poSDKContextDispatch,
        targetEle,
        config,
        res,
        fileName,
        storeDispatch
      );
      const end = new Date();

      if (fileName === '') fileName = fileNameInDoc;

      if (onSuccess) onSuccess(fileName);
      if (sendGAData) sendGAData(end - start);
    } catch (e) {
      storeDispatch(setAppLoading(false));
      poSDKContextDispatch({ type: PO_WEBOFFCE_SDK_FAIL, payload: e.message });
      if (onFail !== undefined) onFail();
    }
  }

  downloadNLoad(url);
}

async function initPoSDKWithRes(dispatch, targetEle, config, res, fileName, storeDispatch) {
  dispatch({ type: PO_WEBOFFCE_SDK_INIT });

  try {
    const instance = await _getInstance(targetEle, config);

    await instance.handle.openNewDocument();

    storeDispatch(setAppLoading(false));

    await instance.handle.openDocument({
      name: fileName || 'downlaodFile.hwp',
      blob: new Blob([res], { type: 'application/x-hwp' })
    });

    dispatch({ type: PO_WEBOFFCE_SDK_SUCCESS, payload: instance });
    const info = await instance.handle.getDocumentInformation();

    return info.title;
  } catch (error) {
    dispatch({ type: PO_WEBOFFCE_SDK_FAIL, payload: error });
  }
}

const POWebofficeSDKStateContext = createContext(null);
const POWebofficeSDKDispatchContext = createContext(null);

export function POWebofficeSDKProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <POWebofficeSDKStateContext.Provider value={state}>
      <POWebofficeSDKDispatchContext.Provider value={dispatch}>
        {children}
      </POWebofficeSDKDispatchContext.Provider>
    </POWebofficeSDKStateContext.Provider>
  );
}

export function usePOWebofficeSDKState() {
  const state = useContext(POWebofficeSDKStateContext);
  if (!state) throw new Error('cannot find POWebofficeSDKProvider');

  return state;
}

export function usePOWebofficeSDKDispatch() {
  const dispatch = useContext(POWebofficeSDKDispatchContext);
  if (!dispatch) throw new Error('cannot find POWebofficeSDKProvider');

  return dispatch;
}
